import Vue from 'vue'
import _debounce from 'lodash.debounce'
import PromiseFileReader from 'promise-file-reader'

export default {
  namespaced: true,
  state: {
    selectedTab: 0,
    selectedTabID: 'venituri',
    selectedPerioadeTab: null,
    selectedPerioadeTabID: null,
    tabs: [
      { _id: 'venituri', label: 'Venituri' },
      { _id: 'chfct', label: 'Cheltuieli FCT' },
      { _id: 'chec', label: 'Cheltuieli ECN' }
    ],
    perioadeTabs: [],
    headers: [],
    items: [],
    total: 0,
    search: null,
    pagination: {
      sortBy: 'createdAt',
      descending: true,
      page: 1,
      rowsPerPage: 10
    },
    loading: false,
    restrictedHeaders: ['_id', 'createdAt', 'updatedAt', 'denumire', 'codec', 'cod', 'ecParent', 'index'],
    hookHeaders: ['createdAt', 'updatedAt', 'cod'],
    minIndex: 9,
    unique: {
    },
    service: {
      path: 'clasificatie',
      headers: 'clasificatieheaders',
      upload: 'clasificatie-upload',
      mainField: 'codec',
      tabField: 'tab',
      perioadeTabField: 'perioada'
    },
    msgTemplates: {
      resource: 'clasificatie bugetara',
      main: 'Cod.ec.'
    }
  },
  getters: {
    tabs: state => state.tabs,
    perioadeTabs: state => state.perioadeTabs,
    selectedTab: state => state.selectedTab,
    selectedTabID: state => state.selectedTabID,
    selectedPerioadeTab: state => state.selectedPerioadeTab,
    selectedPerioadeTabID: state => state.selectedPerioadeTabID,
    headers: state => state.headers,
    items: state => state.items,
    total: state => state.total,
    loading: state => state.loading,
    restrictedHeaders: state => state.restrictedHeaders,
    hookHeaders: state => state.hookHeaders,
    pagination: state => state.pagination,
    minIndex: state => state.minIndex,
    unique: state => state.unique,
    search: state => state.search
  },
  mutations: {
    clearState (state) {
      // state.tabs = [] // nope, because tabs are not dynamic
      state.items = []
      state.headers = []
    },
    setSelectedTab (state, payload) {
      if (state.tabs.length && state.tabs[payload]) {
        state.selectedTab = payload
        state.selectedTabID = state.tabs[payload]._id
      }
    },
    setSelectedPerioadeTab (state, payload) {
      if (state.perioadeTabs.length && state.perioadeTabs[payload]) {
        state.selectedPerioadeTab = payload
        state.selectedPerioadeTabID = state.perioadeTabs[payload]._id
      }
    },
    setHeaders (state, payload) {
      Vue.set(state, 'headers', payload)
    },
    setItems (state, payload) {
      state.items = payload
    },
    setTotal (state, payload) {
      state.total = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setPagination (state, payload) {
      Vue.set(state, 'pagination', payload)
    },
    setSortBy (state, payload) {
      Vue.set(state.pagination, 'sortBy', payload)
    },
    clearUniques (state) {
      Vue.set(state, 'unique', {})
    },
    setUnique (state, payload) {
      const arr = payload.values.map(row => {
        return Object.values(row).join('')
      })
      Vue.set(state.unique, payload.head, arr)
    },
    setSearch (state, payload) {
      state.search = payload
    },
    setPerioadeTabs (state, payload) {
      state.perioadeTabs = payload
    }
  },
  actions: {
    setEventWatchers ({ state, commit, dispatch, rootState }) {
      rootState.services[state.service.path].events.forEach(event => {
        rootState.services[state.service.path].on(event, data => {
          commit('setLoading', true)
          dispatch('fetchHeaders')
          dispatch('fetchItems')
          dispatch('fetchPerioadeTabs')
        })
      })
      rootState.services[state.service.path].on('batchDeleteSuccess', data => {
        dispatch('fetchItems')
      })
      rootState.services[state.service.headers].events.forEach(event => {
        rootState.services[state.service.headers].on(event, data => {
          commit('setLoading', true)
          dispatch('fetchHeaders')
          dispatch('fetchItems')
          dispatch('fetchPerioadeTabs')
        })
      })
    },
    fetchTabs: _debounce(({ commit, rootState, state, dispatch }) => {
    }, 1000),
    fetchPerioadeTabs: _debounce(({ commit, rootState, state, dispatch }) => {
      commit('setLoading', true)
      rootState.feathers.service('cifuriperioade').find({
        query: {
          $paginate: false,
          $sort: {
            date: -1
          },
          $select: ['_id', 'label']
        }
      }).then(result => {
        commit('setPerioadeTabs', result)
        // if (state.selectedPerioadeTab === null && result[0]) {
        if (result[0]) {
          commit('setSelectedPerioadeTab', 0)
        }
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare perioade... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchHeaders: _debounce(({ commit, rootState, state, dispatch }) => {
      commit('setLoading', true)
      rootState.feathers.service(state.service.headers).find({
        query: {
          $paginate: false,
          $sort: {
            index: 1
          },
          [state.service.tabField]: state.selectedTabID,
          [state.service.perioadeTabField]: state.selectedPerioadeTabID
        }
      }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire proprietati "${state.msgTemplates.resource}" reusita.`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        commit('setHeaders', result)
        dispatch('fetchUniques', result)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare proprietati "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchItems: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      if (!state.pagination.sortBy) {
        commit('setSortBy', 'createdAt')
      }

      let skip = 0

      let query = {}
      if (state.pagination.rowsPerPage === -1) {
        query = {
          $paginate: false
        }
      } else {
        skip = state.pagination.rowsPerPage * (state.pagination.page - 1)
        query = {
          $limit: state.pagination.rowsPerPage,
          $skip: skip
        }
      }

      query.$sort = {
        [state.pagination.sortBy || 'createdAt']: state.pagination.descending ? -1 : 1
      }

      if (state.search && state.search.length) {
        query.$search = state.search
      }

      query[state.service.tabField] = state.selectedTabID
      query[state.service.perioadeTabField] = state.selectedPerioadeTabID

      rootState.feathers.service(state.service.path).find({ query }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire "${state.msgTemplates.resource}" reusita. Pagina: ${state.pagination.page}, Total: ${result.total || result.length || 0}`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        if (state.pagination.rowsPerPage === -1) {
          commit('setItems', result)
          commit('setTotal', result.length)
        } else {
          commit('setItems', result.data)
          commit('setTotal', result.total)
        }

        const { page, ...pagination } = state.pagination
        if (page > 1 && skip > result.total) {
          pagination.page = 1
          dispatch('paginationChanged', pagination)
        }
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchUniques ({ state, commit, rootState, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearUniques')
      payload.forEach(header => {
        if (header.rules.includes('unique')) {
          rootState.feathers.service(state.service.path).find({
            query: {
              $distinct: header.value,
              [state.service.tabField]: state.selectedTabID,
              [state.service.perioadeTabField]: state.selectedPerioadeTabID
            }
          }).then(result => {
            commit('setUnique', { head: header.value, values: result })
          }).catch(err => {
            dispatch('saveMessage', {
              user: rootState.auth.user._id,
              text: `Eroare la interogare valori unice "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
              timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
              type: 'error'
            }, { root: true })
            commit('setLoading', false)
          }).finally(() => {
            commit('setLoading', false)
          })
        }
      })
    },
    search ({ commit, dispatch }, payload) {
      commit('setSearch', payload)
      dispatch('fetchItems')
    },
    toggleHeadVisibility ({ state, rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services[state.service.headers].patch(payload.id, {
        visible: payload.visibility
      }).then(result => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Vizibilitatea proprietatii ${result.label} din colectia "${state.msgTemplates.resource}" a fost schimbata in ${result.visible ? '"vizibil"' : '"ascuns"'}!`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'info'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la schimbarea vizibilitatii unei proprietati in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    addHeader ({ rootState, state, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services[state.service.headers].create({
        ...payload,
        [state.service.tabField]: state.selectedTabID,
        [state.service.perioadeTabField]: state.selectedPerioadeTabID
      }).then(res => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `A fost adaugata proprietatea "${res.label}" in colectia "${state.msgTemplates.resource}".`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la adaugare proprietate in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    editHeader ({ state, rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      const label = payload.values.label
      rootState.services[state.service.headers].patch(payload.id, payload.values).then(res => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `A fost modificata proprietatea "${res.label}" in colectia "${state.msgTemplates.resource}".`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la modificare proprietate "${label}" in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    deleteHeader ({ state, rootState, commit, dispatch }, payload) {
      if (payload.id) { // make sure there's an ID so we don't delete everything
        commit('setLoading', true)
        rootState.services[state.service.headers].remove(payload.id).then(res => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `A fost stearsa proprietatea "${res.label}" din colectia "${state.msgTemplates.resource}".`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'success'
          }, { root: true })
        }).catch(err => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `Eroare la stergerea unei proprietati din colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          }, { root: true })
        }).finally(() => {
          commit('setLoading', false)
        })
      }
    },
    addItem ({ rootState, state, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services[state.service.path].create({
        ...payload,
        [state.service.tabField]: state.selectedTabID,
        [state.service.perioadeTabField]: state.selectedPerioadeTabID
      }).then(res => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `A fost adaugat un element in colectia "${state.msgTemplates.resource}". ${state.msgTemplates.main}: "${res.denumire_apl}"`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la adaugare element in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    editItems ({ state, rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      payload.items.forEach(item => {
        const label = item[state.service.mainField]
        rootState.services[state.service.path].patch(item._id, item).then(res => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `A fost modificat un element in colectia "${state.msgTemplates.resource}"... ${state.msgTemplates.main}: "${res[state.service.mainField]}"`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'success'
          }, { root: true })
        }).catch(err => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `Eroare la modificare element cu ${state.msgTemplates.main}: ${label} in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          }, { root: true })
        }).finally(() => {
          commit('setLoading', false)
        })
      })
    },
    deleteItems ({ state, rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      rootState.services['delete-worker']
        .remove({ items: payload.ids, service: state.service.path })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    paginationChanged ({ commit, dispatch }, payload) {
      commit('setPagination', payload)
      dispatch('fetchItems')
    },
    setSelectedTab ({ state, commit, dispatch }, payload) {
      const pos = state.tabs.findIndex(tab => tab._id === payload)
      if (pos > -1) {
        commit('setItems', [])
        commit('setHeaders', [])
        commit('setSelectedTab', pos)
        dispatch('fetchHeaders')
        dispatch('fetchItems')
      }
    },
    setSelectedPerioadeTab ({ state, commit, dispatch }, payload) {
      const pos = state.perioadeTabs.findIndex(tab => tab._id === payload)
      if (pos > -1) {
        commit('setItems', [])
        commit('setHeaders', [])
        commit('setSelectedPerioadeTab', pos)
        dispatch('fetchHeaders')
        dispatch('fetchItems')
      }
    },
    importFromFile ({ commit, dispatch, rootState, state }, payload) {
      return PromiseFileReader.readAsDataURL(payload).then(result => {
        commit('setLoading', true)
        return rootState.services[state.service.upload].create({ file: result, [state.service.tabField]: state.selectedTabID, [state.service.perioadeTabField]: state.selectedPerioadeTabID })
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la citire fisier... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      }).finally(() => {
        commit('setLoading', false)
      })
    },
    acceptImport ({ state, rootState, commit, dispatch }, payload) {
      commit('setLoading', true)
      if (payload.id) {
        rootState.services[state.service.upload].remove(payload.id, { query: {
          headers: payload.headers,
          mode: payload.mode
        } }).catch(err => {
          dispatch('saveMessage', {
            user: rootState.auth.user._id,
            text: `Eroare la salvare bulk in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
            timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
            type: 'error'
          }, { root: true })
          dispatch('fetchHeaders')
          dispatch('fetchItems')
        }).finally(() => commit('setLoading', false))
      }
    },

    async nuke ({ state, rootState, commit }) {
      try {
        commit('setLoading', true)
        await rootState.services['delete-worker'].remove({ service: state.service.path, query: { [state.service.perioadeTabField]: state.selectedPerioadeTabID } })
      } catch (err) {
        console.error(err)
      } finally {
        commit('setLoading', false)
      }
    },

    async importHeaders ({ state, rootState, commit, dispatch }, payload) {
      try {
        commit('setLoading', true)

        await rootState.services[state.service.headers].create({ op: 'import', perioadaFrom: payload.perioada, perioadaTo: state.selectedPerioadeTabID })
        dispatch('fetchHeaders')
        dispatch('fetchItems')

        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Capete de tabel copiate in colectia "${state.msgTemplates.resource}".`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'success'
        }, { root: true })
      } catch (err) {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare copiere capete de tabel in colectia "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
      } finally {
        commit('setLoading', false)
      }
    }
  }
}
